module.exports = __webpack_public_path__ + "img/home_map_Philippines_blue.b84482bb.png";